import type { SessionUser } from "../../types/auth";

const SESSION_ENDPOINT = "/auth/session";

export interface SessionResponse {
  user: SessionUser | null;
  /** Server-computed from the admin email allowlist; never derive this client-side. */
  hasBackofficeAccess: boolean;
}

/**
 * Fetches the same `/auth/session` endpoint `contexts/AuthContext.tsx` already uses, with the
 * same "never throw, fall back to signed-out" behavior — a failed/non-ok session check should
 * read as "not signed in", not surface as a query error the UI has to render an error state for.
 */
export async function fetchSession(): Promise<SessionResponse> {
  const res = await fetch(SESSION_ENDPOINT, {
    credentials: "include",
    cache: "no-store",
    headers: { Accept: "application/json" },
  });

  if (!res.ok) {
    return { user: null, hasBackofficeAccess: false };
  }

  const data = (await res.json()) as { user: SessionUser | null; hasBackofficeAccess?: boolean };
  return { user: data?.user ?? null, hasBackofficeAccess: data?.hasBackofficeAccess ?? false };
}
